import * as di from "react-icons/di";
import * as fa from "react-icons/fa";
import * as si from "react-icons/si";

const techstacks = [

    si.SiDart,
    si.SiJavascript,
    // DiJava,
    // TbBrandGolang,

    // Frameworks & Libraries
    si.SiFlutter,
    di.DiReact,
    si.SiBootstrap,

    // Backend & Platforms
    di.DiNodejs,
    si.SiFirebase,

    // Databases
    di.DiMongodb,
    si.SiMysql,
    si.SiPostgresql,
    si.SiSqlite,

    // Web Technologies
    si.SiHtml5,
    si.SiCss3,

    // Tools
    si.SiGithub,
    si.SiGit,
];


const tools = [
    // IDEs & Code Editors
    si.SiVisualstudiocode,
    si.SiAndroidstudio,

    // API Tools
    si.SiPostman,
    si.SiSwagger,

    // Version Control & Repos
    si.SiGithub,
    si.SiGit,

    // Deployment & Hosting
    si.SiVercel,
    fa.FaAws,

    // Operating Systems
    si.SiIos,
    si.SiMacos,
    si.SiWindows,

];



export { techstacks, tools }